// CardSection.js
import { Link } from 'react-router-dom';
import styles from './styles/CardSection.module.css';

const CardSection = ({ image, Icon, label, route }) => (
  <Link to={route} className={styles.card}>
    <div className={styles.iconContainer}>
      {Icon ? (
        <Icon size={40} strokeWidth={1.5} className={styles.icon} />
      ) : (
        <img src={image} alt="" className={styles.image} />
      )}
    </div>
    <span className={styles.label}>{label}</span>
  </Link>
);

export default CardSection;
